<template>
<div class="popup" v-cloak v-if="addUserSubAccountShow">
    <div class="content" id="add-user-sub-account">
        <div class="title">
            <span>{{$t('language.popup.subAccountPopup.addUser.title')}}</span>
            <div class="icon white-close dialog-close" @click="closePage()"></div>
        </div>
        <div class="add-user-sub-account-content">
            <div class="add-user-sub-account-radio" @click="checkRadio(0)">
                <div class="icon-util radio radio-position" :class="[0==clickCurrent?'check-radio':'']"></div>
                <div class="radio-content">{{$t('language.popup.subAccountPopup.addUser.radioCreate')}}</div>
            </div>
            <div class="add-user-sub-account-input" v-if="0==clickCurrent">
                <input type="text" name="createName" :readonly="loadingStart" v-model="createName" :placeholder="$t('language.popup.subAccountPopup.addUser.createNamePlaceholder')"/>
                <input type="password" name="createPassword" :readonly="loadingStart" v-model="createPassword" :placeholder="$t('language.popup.subAccountPopup.addUser.createPasswordPlaceholder')"/>
            </div>
            <div class="add-user-sub-account-radio" style="margin-top: 15px;" @click="checkRadio(1)">
                <div class="icon-util radio radio-position" :class="[1==clickCurrent?'check-radio':'']"></div>
                <div class="radio-content">{{$t('language.popup.subAccountPopup.addUser.radioAdd')}}</div>
            </div>
            <div class="add-user-sub-account-input" v-if="1==clickCurrent">
                <input type="text" name="addUserName" :readonly="loadingStart" v-model="addUserName" :placeholder="$t('language.popup.subAccountPopup.addUser.addNamePlaceholder')"/>
            </div>
        </div>
        <div class="add-user-sub-account-footer">
            <!-- <span class="add-user-sub-account-footer-error" v-if="0==clickCurrent&&userNameStatus">This account already exists</span>
            <span class="add-user-sub-account-footer-error" v-if="1==clickCurrent&&userNameStatus">This account doesn't exist</span> -->
            <button @click="addUser()" v-loading="loadingStart"><span>{{$t('language.common.ok')}}</span></button>
        </div>
    </div>
    <upgradeDialog ref="upgradeDialog"></upgradeDialog>
</div>
</template>

<script>
import commonUtils from "@/js/workspace/common_util.js";
import commonstate from '@/js/constant.js';
//显示账号升级弹窗
import upgradeDialog from "@/components/popup/upgrade_popups/upgrade_account_popup";

export default {
    data: function () {
        return {
            user: commonstate.user,
            createName: "",
            createPassword: "",
            addUserName: "",
            addUserSubAccountShow: false,
            clickCurrent: 0,
            userNameStatus: false,
            folderItem: {},//同步添加文件信息
            loadingStart: false,
        }
    },
    components:{
    upgradeDialog
    },
    methods: {
        //关闭弹窗
        closePage() {
            this.addUserSubAccountShow = false;
            this.createName = "";
            this.createPassword = "";
            this.addUserName = "";
            this.userNameStatus = false;
            this.clickCurrent = 0;
            this.folderItem = {};
            this.loadingStart = false;
        },
        //选则添加还是新增
        checkRadio(index){
            this.clickCurrent = index;
            switch (this.clickCurrent) {
                case 0:
                    this.addUserName = "";
                    break;
                case 1:
                    this.createName = "";
                    this.createPassword = "";
                    break;
            }
        },
        addUser(){
             let user=commonUtils.getUser();
            //如果用户是免费用户则弹出升级弹窗
            if(!user.vip){
               this.$refs.upgradeDialog.upgradeShow=true;
               this.$refs.upgradeDialog.accountsShow=true;
               return;
            }
            switch (this.clickCurrent) {
                case 0:
                    this.createSubAccount();
                    break;
                case 1:
                    //是否同步添加项目信息
                    if(this.folderItem){
                        this.addPermission(this.addUserName);
                    }else{
                        this.addSubAccount();
                    }
                    break;
            }
        },
        //检验用户名是否重复
        //注册新的子用户
        createSubAccount(){
            //验证用户名
            if (!this.createName) {
                this.$toast({
                    text: this.$t('language.popup.subAccountPopup.addUser.createNameNone'),
                    type: 'fail',
                    idValue: "add-user-sub-account"
                });
                return false;
            }else if(this.createName.length>20){
                this.$toast({
                    text: this.$t('language.popup.subAccountPopup.addUser.createNameMore'),
                    type: 'fail',
                    idValue: "add-user-sub-account"
                });
                return false;
            }
            //验证密码
            if (!this.createPassword) {
                this.$toast({
                    text: this.$t('language.popup.subAccountPopup.addUser.createPasswordNone'),
                    type: 'fail',
                    idValue: "add-user-sub-account"
                });
                return false;
            }else if(this.createPassword.length>16||this.createPassword.length<8){
                this.$toast({
                    text: this.$t('language.popup.subAccountPopup.addUser.createPasswordError'),
                    type: 'fail',
                    idValue: "add-user-sub-account"
                });
                return false;
            }
            let data = {
                ud : this.user.id,
                name: this.createName,
                password: this.createPassword,
            }
            this.loadingStart = true;
            this.Utils.doSubAccountRequest("add", data).then(res => {
                this.loadingStart = false;
                if(res.status=="200"){
                    if(this.folderItem){
                        this.addPermission(this.createName);
                        return;
                    }
                    this.$parent.getPermissionList();
                    this.closePage();
                }else if(res.reason=="userExist"){
                    this.$toast({
                        text: this.$t('language.popup.subAccountPopup.userExist'),
                        type: 'fail',
                        idValue: "add-user-sub-account"
                    });
                }else if(res.message){
                    this.$toast({
                        text: res.message,
                        type: 'fail',
                        idValue: "add-user-sub-account"
                    });       
                }else{
                    this.$toast({
                        text: this.$t('language.exception.' + res.reason),
                        type: 'fail',
                        idValue: "add-user-sub-account"
                    });
                }
            })
        },
        //添加已有的空白子用户
        addSubAccount(){
            if(!this.addUserName){
                this.$toast({
                    text: this.$t('language.popup.subAccountPopup.addUser.addUserNameNone'),
                    type: 'fail',
                    idValue: "add-user-sub-account"
                });
                return false;
            }
            let data = {
                ud : this.user.id,
                email: this.addUserName,
            }
            this.loadingStart = true;
            this.Utils.doPermissionRequest("add_user", data).then(res => {
                this.loadingStart = false;
                if(res.status=="200"){
                    this.$parent.getPermissionList();
                    this.closePage();
                }else if(res.status=="400"){
					if(res.reason == "addUserNone"){
						this.$toast({
						    text: this.$t('language.popup.subAccountPopup.addUser.addUserNone'),
						    type: 'fail',
						    idValue: "add-user-sub-account"
						});
					}else{
						this.$toast({
						    text: this.$t('language.popup.subAccountPopup.' + res.reason),
						    type: 'fail',
						    idValue: "add-user-sub-account"
						});
					}
                }else {
                    this.$toast({
                        text: res.message,
                        type: 'fail',
                        idValue: "add-user-sub-account"
                    });                    
                }
            })
        },
        //同步添加项目信息
        addPermission(email){
            let data = {
                ud : this.user.id,
                email: email,
                cloudType: this.folderItem.cloudType,
                cloudId: this.folderItem.cloudId,
                folderId: this.folderItem.folderId,
                folderName: this.folderItem.folderName,
                own: this.user.id,
            }
            this.loadingStart = true;
            this.Utils.doPermissionRequest("add_limit", data).then(res => {
                this.loadingStart = false;
                if(res.status=="200"){
                    this.$parent.getPermissionList();
                    this.closePage();
                }else if(res.status=="400"&&res.reason=="userExist"){
                    this.$toast({
                        text: this.$t('language.popup.subAccountPopup.userExist'),
                        type: 'fail',
                        idValue: "add-user-sub-account"
                    });
                }else if(res.status=="400"&&res.reason=="addUserNone"){
                    this.$toast({
                        text: this.$t('language.popup.subAccountPopup.addUser.addUserNone'),
                        type: 'fail',
                        idValue: "add-user-sub-account"
                    });
                }else if(res.status=="400"&&res.reason=="userSelf"){
                    this.$toast({
                        text: this.$t('language.popup.subAccountPopup.userSelf'),
                        type: 'fail',
                        idValue: "add-user-sub-account"
                    });
                }else if(res.message){
                    this.$toast({
                        text: res.message,
                        type: 'fail',
                        idValue: "add-user-sub-account"
                    });       
                }else{
                    this.$toast({
                        text: this.$t('language.exception.' + res.reason),
                        type: 'fail',
                        idValue: "add-user-sub-account"
                    });
                }
            })
        }
    }
}
</script>

<style>
#add-user-sub-account {
    width: 450px;
    /*no*/
    height: 300px;
    /*no*/
}

.add-user-sub-account-content {
    font-size: 14px;
    /*no*/
    color: rgba(0, 0, 0, 0.6);
    padding: 15px 20px 0 20px;
    /*no*/
}

.add-user-sub-account-footer {
    width: 100%;
    position: absolute;
    bottom: 0;
}

.add-user-sub-account-footer button{
    float: right;
    margin: 0 20px 20px 0;/*no*/
    width: 100px;/*no*/
}

.add-user-sub-account-radio {
    margin: 5px 0;/*no*/
    height: 16px;/*no*/
    cursor: pointer;
}

.add-user-sub-account-radio .radio-content {
    float: left;
}

.add-user-sub-account-radio .radio-position {
    float: left;
    margin: 1px 5px 0 0;/*no*/
}

.add-user-sub-account-input input{
    margin-top: 15px;/*no*/
}

.add-user-sub-account-footer-error {
    font-size: 12px;/*no*/
    color: red;position: absolute;
    bottom: 25px;/*no*/
    left: 20px;/*no*/
}

#add-user-sub-account .el-loading-spinner .circular {
    height: 25px !important;
    /*no*/
    width: 25px !important;
    /*no*/
}

#add-user-sub-account .el-loading-spinner {
    margin-top: 0rem !important;
    top: 7%;
}
</style>



// WEBPACK FOOTER //
// src/components/popup/sub_account_popups/add_user_popup.vue